export interface FormIdState {
  value: string;
}

export const formIdStateActions = ['form_id_create'] as const;

export type FormIdStateAction = (typeof formIdStateActions)[number];
